/* unplugin-vue-components disabled */import script from "./vip copy.vue?vue&type=script&setup=true&lang=js"
export * from "./vip copy.vue?vue&type=script&setup=true&lang=js"

import "./vip copy.vue?vue&type=style&index=0&id=07229c72&lang=scss&scoped=true"
import "./vip copy.vue?vue&type=style&index=1&id=07229c72&lang=scss"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07229c72"]])

export default __exports__